// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".point-circle[data-v-2f60affe]{background:linear-gradient(180deg,#fff 15.63%,#dbdbdb 171.87%);filter:drop-shadow(0 1px 4px rgba(0,0,0,.44))}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
